import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const ArrowLeftIcon: React.FC<Props> = ({
  color = '#1C1C1F',
  width = 18,
  height = 18,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
  >
    <path
      d="M6.23895 5.21045L3.26456 8.33003C2.91181 8.7 2.91181 9.29984 3.26456 9.66981L6.23895 12.7894M3.52913 8.99993H11.8421"
      stroke={color}
      strokeWidth="1.26316"
      strokeLinecap="round"
    />
    <path
      d="M15 4.36841V13.6316"
      stroke={color}
      strokeWidth="1.26316"
      strokeLinecap="round"
    />
  </svg>
);
